import { saveAs } from 'file-saver';
import prettyBytes from 'pretty-bytes';
import { ElementType, ReactNode, useCallback } from 'react';

import entityContainerConnector from '~components/generic/entityContainerConnector';
import useAppSelector from '~hooks/useAppSelector';
import usePermissions from '~hooks/usePermissions';
import { shareFileCms } from '~services/api/calls/file';
import { getAbsoluteUrl } from '~store/getter';
import { selectConfigMyFilesEnabled } from '~store/selectors';
import { Download } from './Download';

type CmsDownloadComponentProps = {
  data: Entity;
  description?: ReactNode;
  as?: ElementType;
};

function CmsDownloadComponent({ data, description, as }: CmsDownloadComponentProps) {
  const isSharingEnabled = useAppSelector(selectConfigMyFilesEnabled);
  const filename = data.attributes?.filename || '';
  const url = data.attributes.url ? getAbsoluteUrl(data.attributes.url) : null;
  const size = prettyBytes(data.attributes?.filesize || 0);
  const { hasViewMyFilesPermission } = usePermissions();

  const handleShare = useCallback(() => {
    if (isSharingEnabled && url) {
      shareFileCms(url);
    }
  }, [isSharingEnabled, url]);

  const handleDownload = useCallback(() => {
    if (url) {
      saveAs(url, filename);
    }
  }, [url, filename]);

  if (data) {
    return (
      <Download
        filename={filename}
        isSharingEnabled={isSharingEnabled}
        onShare={handleShare}
        onDownload={handleDownload}
        size={size}
        description={description}
        as={as}
        showAddToMyFiles={hasViewMyFilesPermission}
      />
    );
  }
  return null;
}

export const CmsDownload = entityContainerConnector(CmsDownloadComponent);
